/* 统计 ev pv */
let uniqid = window.localStorage.uniqid
// const setBusinessBrowse = (getApi, id) => {
//   getApi('Public/setBusinessBrowse', {
//     uniqid: uniqid,
//     shop_id: id
//   })
// }
const setBrowse = (getApi, to, shopId = '') => {
  getApi('Public/setAdminBrowse', {
    uniqid: uniqid
  })
  // let id = ''
  // if (to.name === 'ShopDetails') {
  //   id = to.query.id
  //   setBusinessBrowse(getApi, id)
  // } else if (to.name === 'goodsDe') {
  //   id = to.query.shopId
  //   setBusinessBrowse(getApi, id)
  // } else if (to.name === 'secondGoodsDe') {
  //   id = to.query.shopId
  //   setBusinessBrowse(getApi, id)
  // }
}
export default setBrowse



// WEBPACK FOOTER //
// ./src/js/setBrowse.js